import * as React from 'react';
import * as styles from './BuildersLink.css';
import { ArticleParagraph2, IconArrowUpRight16, IconBuilder16 } from '@cian/ui-kit';

interface IBuildersLinkProps {
  link: string;
}

export const BuildersLink: React.FC<IBuildersLinkProps> = ({ link }) => {
  return (
    <a className={styles['link']} href={link} target="_blank" rel="noreferrer">
      <IconBuilder16 color="primary_100" />
      <div className={styles['link-name']}>
        <ArticleParagraph2 color="primary_100" as="span">
          В каталог строительных компаний
        </ArticleParagraph2>
      </div>
      <IconArrowUpRight16 color="primary_100" stroke="white" />
    </a>
  );
};
